// src/pages/maintenance/components/MaintenanceContractList/useMaintenanceContractFormLogic.js

import { useState, useEffect } from 'react';
import API_BASE_URL from '../../../../Constants';


const useMaintenanceContractFormLogic = (open, contractId = null) => {
  const [formData, setFormData] = useState({});
  const [options, setOptions] = useState({});

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [
          buildingsRes,
          contractClassesRes,
          coverageTypesRes,
          coveragesRes,
          visitFrequenciesRes,
          billingLevelsRes,
          billingFrequencyRes,
          holdPeriodsRes
        ] = await Promise.all([
          fetch(API_BASE_URL + '/api/setup/buildings/all', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/contractclasses', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancecoveragetypes', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancecoverages', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancefrequencies', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancebillinglevels', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenancebillingfrequencies', { credentials: 'include' }).then(res => res.json()),
          fetch(API_BASE_URL + '/api/maintenance/maintenanceholdperiods', { credentials: 'include' }).then(res => res.json())
        ]);

        setOptions({
          buildingId: buildingsRes || [],
          contractClass: contractClassesRes || [],
          coverageType: coverageTypesRes || [],
          coverage: coveragesRes || [],
          visitFrequency: visitFrequenciesRes || [],
          billingLevel: billingLevelsRes || [],
          billingFrequency: billingFrequencyRes || [],
          holdPeriod: holdPeriodsRes || [],
        });
      } catch (error) {
        console.error('Error fetching dropdown options:', error);
      }
    };


    const fetchContractData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenance-contracts/${contractId}`, {
          credentials: 'include'
        });
        const data = await response.json();
        setFormData(data);
      } catch (error) {
        console.error('Error fetching maintenance contract:', error);
      }
    };


    if (open) {
      fetchOptions();
      if (contractId) {
        fetchContractData();
      } else {
        setFormData({}); // Reset form for adding new contract
      }
    }
  }, [open, contractId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return {
    formData,
    setFormData,
    options,
    handleInputChange,
  };
};

export default useMaintenanceContractFormLogic;
